/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanProvisioningProfileDto { 
    id?: number;
    loanProvisioningCriteriaId?: number | null;
    provisioningCategoryName?: string | null;
    minDays?: number;
    maxDays?: number | null;
    provisionPercentage?: number | null;
    liabilityAccountLedgerCode?: string | null;
    expensesAccountLedgerCode?: string | null;
    incomeAccountLedgerCode?: string | null;
    tenantId?: number;
}

